export default "__VITE_ASSET__B8Vx3dKg__"